import { render, staticRenderFns } from "./DummyAction.vue?vue&type=template&id=18615ed2"
import script from "./DummyAction.vue?vue&type=script&lang=js"
export * from "./DummyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports